import React from "react";
import CareersForm from "../components/careersForm/careers";

function ContactPage() {
  return (
    <>
      <CareersForm />
    </>
  );
}

export default ContactPage;
